import { useQuery } from '@tanstack/react-query';
import { awpStatusKey, mapToAwpStatus, requestMyAwpStatus } from './awpStatusApi';

/** The member's last-exam and next-eligible AWP dates. Self-scoped: there is no id to pass. */
export function useAwpStatus() {
  const { data, isPending, isError } = useQuery({
    queryKey: awpStatusKey,
    queryFn: requestMyAwpStatus,
    select: mapToAwpStatus,
  });

  return { data, isPending, isError };
}
